import common from './common'
import system from './system'
import recordManage from './recordManage'
import oiltabkManage from './oiltabkManage'
import timeconfig from './timeconfig'
import invoiceManage from './invoiceManage'
import grainSpecifications from './grainSpecifications'
import grainType from './grainType'
import userBond from './userBond'
import yxcUserBond from './yxcUserBond'
import orderManage from './orderManage'
import yxcOrderManage from './yxcOrderManage'
import yxcPurchaseDemand from './yxcPurchaseDemand'
import deliveryOrder from './deliveryOrder'
import yxcDeliveryOrder from './yxcDeliveryOrder'
import bondRecord from './bondRecord'
import yxcBondRecord from './yxcBondRecord'
import priceControl from './priceControl'
import oilTankCost from './oilTankCost'
import customerOilStorage from './customerOilStorage'
import rentManage from './rentManage'
import flowManage from './flowManage'
import cyCrkManage from './cyCrkManage'
import inspectionPoint from './inspectionPoint'
import inspectionRecord from './inspectionRecord'
import patrolProblemReport from './patrolProblemReport'
import qualityControlReport from './qualityControlReport'
import technologicalInnovation from './technologicalInnovation'
import greenEnergy from './greenEnergy'
import expenseManage from './expenseManage'
import accessory from './accessory'
import ingredients from './ingredients'
import productionProcess from './productionProcess'
import vehicleManage from './vehicleManage'
import vehicleAccess from './vehicleAccess'
import equipmentLedger from './equipmentLedger'
import firefightingClockIn from './firefightingClockIn'
import fireLedger from './fireLedger'
import specialEquipment from './specialEquipment'
import specialWork from './specialWork'
import materialsManage from './materialsManage'
import tenderDocument from './tenderDocument'
import purchaseOrders from './purchaseOrders'
import purchaseDelivery from './purchaseDelivery'
import purchaseInvoice from './purchaseInvoice'
import supplier from './supplier'
import eventRecord from './eventRecord'
import rawMaterialSupplier from './rawMaterialSupplier'
import supplierPayment from './supplierPayment'
import wspb from './wspb'
import clyy from './clyy'
import lyInvoice from './lyInvoice'
import prodManage from './prodManage'
import carManage from './carmanage'
import sealApply from './sealApply'
import purchaseYx from './purchaseYx'
import shipRecord from './shipRecord'
import yxcUserPayer from './yxcUserPayer'
import vehicleBlack from './vehicleBlack'
import financeLoan from './financeLoan'
import wlFreight from './wlFreight'
import performance from './performance'
import productionPerformance from './productionPerformance'
import typeQcReport from './typeQcReport'

export default {
  common,
  system,
  recordManage,
  oiltabkManage,
  timeconfig,
  invoiceManage,
  grainSpecifications,
  grainType,
  userBond,
  yxcUserBond,
  orderManage,
  yxcOrderManage,
  yxcPurchaseDemand,
  deliveryOrder,
  yxcDeliveryOrder,
  bondRecord,
  yxcBondRecord,
  priceControl,
  oilTankCost,
  customerOilStorage,
  rentManage,
  flowManage,
  cyCrkManage,
  inspectionPoint,
  inspectionRecord,
  patrolProblemReport,
  qualityControlReport,
  technologicalInnovation,
  greenEnergy,
  expenseManage,
  accessory,
  ingredients,
  productionProcess,
  vehicleManage,
  vehicleAccess,
  equipmentLedger,
  firefightingClockIn,
  fireLedger,
  specialEquipment,
  specialWork,
  materialsManage,
  tenderDocument,
  purchaseOrders,
  purchaseDelivery,
  purchaseInvoice,
  supplier,
  eventRecord,
  rawMaterialSupplier,
  supplierPayment,
  wspb,
  clyy,
  lyInvoice,
  prodManage,
  carManage,
  sealApply,
  purchaseYx,
  shipRecord,
  yxcUserPayer,
  vehicleBlack,
  financeLoan,
  wlFreight,
  performance,
  productionPerformance,
  typeQcReport
}
